import { Heading, Text } from "@chakra-ui/react";
import React from "react";
import BasicPage from "../BasicPage";
import SupportArea from "./SupportArea";

const EmailVerifiedPage = () => {
  return (
    <BasicPage type="modal">
      <Heading>Email verified</Heading>
      <Text fontSize="sm">
        You've successfully verified your email. In the future, you'll
        be able to use this email address and the password you chose during
        registration to manage your subscription.
      </Text>
      <SupportArea />
    </BasicPage>
  );
};

export default EmailVerifiedPage;
